export let FlexBoxDirection = /*#__PURE__*/function (FlexBoxDirection) {
  /**
   * Items are placed top to bottom.<br />
   * <b>Note:</b> Corresponds to `column`.
   */
  FlexBoxDirection["Column"] = "Column";
  /**
   * Items are placed bottom to top.<br />
   * <b>Note:</b> Corresponds to `column-reverse`.
   */
  FlexBoxDirection["ColumnReverse"] = "ColumnReverse";
  /**
   * Items are placed left to right in `ltr` and right to left in `rtl`.<br />
   * <b>Note:</b> Corresponds to `row`.
   */
  FlexBoxDirection["Row"] = "Row";
  /**
   * Items are placed right to left in `ltr` and left to right in `rtl`.<br />
   * <b>Note:</b> Corresponds to `row-reverse`.
   */
  FlexBoxDirection["RowReverse"] = "RowReverse";
  return FlexBoxDirection;
}({});